import { createSlice } from "@reduxjs/toolkit";
import { NavigationLink } from "../../models/navigation-link";
import { NavigationThunk } from "./thunks";

interface UserState {
  navigation: NavigationLink[];
  loading: boolean;
  error: string | null;
}

export const initialState: UserState = {
  navigation: [],
  loading: false,
  error: null
};

export const navigationSlice = createSlice({
  name: "navigation",
  initialState: initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(NavigationThunk.fulfilled, (state, action) => {
      const navigationLinks = action.payload;
      if (!navigationLinks) {
        state.loading = false;
        state.navigation = [];
        state.error = "user not authenticated";
        return;
      }
      state.navigation = navigationLinks;
      state.loading = false;
      state.error = "";
    });
    builder.addCase(NavigationThunk.rejected, (state, action) => {
      state.loading = false;
      state.navigation = [];
      state.error = "user not authenticated";
    });
    builder.addCase(NavigationThunk.pending, (state, action) => {
      state.navigation = [];
      state.error = "";
      state.loading = true;
    });
  }
});

export default navigationSlice.reducer;
